
import React, {useCallback, useState}   from 'react'

import FullCalendar                     from '@fullcalendar/react'
import resourceTimeGridPlugin           from '@fullcalendar/resource-timegrid';
import resourceDayGridPlugin            from '@fullcalendar/resource-daygrid';
import interactionPlugin                from '@fullcalendar/interaction';
import  {inPast,getDateStr}             from '../../lib/iprs-react-library/src/index.js';
import {LoadingIndicator as Loading}    from '../../lib/iprs-react-library/src/index.js';
import useBookingState, {B_ACTIONS}     from '../Booking/bookingReducer'
import {appointmentTypeDayStartTime}    from '../Util/earlyStart'


/* This is the license key which allows use of paid for views of the calendar.
 * See env.local and .env files. */
const schedulerLicenseKey =  process.env.REACT_APP_SCHEDULER_LICENSE_KEY

/**
 * 
 */
const AppointmentCalendarInternal = ({api, state, setSelectedEvent, eventDispatch}) => {
    
    const { appType: {  appointmentTypeID, appointmentTypes = {} }, booking } = state;

    const selectedAppType =  appointmentTypes.find(at => appointmentTypeID === at.AppointmentTypeID);
    const selectedAppTypeName = selectedAppType?.Title;
    const selectedColour = selectedAppType?.Colour;

    /* The start of the working day for this appointment type; earlier than
     * normal for the types listed in REACT_APP_CHRONOS_EARLY_START_APP_TYPES. */
    const dayStartTime = appointmentTypeDayStartTime(appointmentTypeID);

    const [loading, setLoading]                         = useState(false);
    const [, bookingUpdater] = useBookingState(state, eventDispatch);
    
    const eventSource = useCallback( (info, successCallback, failureCallback) => {
        
        let clinician = booking?.newBooking?.clinician?.partyID?? 0;

        const params = {
            AppointmentTypeID: appointmentTypeID,
            Multiplier: 1,
            StartTime: info.startStr,
            FinishTime: info.endStr
        };

        const isVisual = booking?.newBooking?.isVisual?? false;
        if (isVisual) {
            params.IsVisual = true;
        }
        if (clinician) {
            params.ClinicianPartyID = clinician;
        }

        api.transact('GetSlots', params )
        .then ( response => response.apiResult ) 
        .then( apiResult => apiResult.map( a => 
                { 
                    const colour = inPast(a.StartTime) ? 'gray' : selectedColour;
                    return {    id: a.RotaID ,title: 'Available', resourceId: a.PartyID, 
                                start: a.StartTime, end: a.FinishTime, 
                                apiEvent: a, backgroundColor: colour } } ) )
        .then ( r => {
            const futureSlots = r.filter(d => !inPast(d.start));
            if (futureSlots.length > 0){
                let earliestTimeSlot = futureSlots
                                        .sort( (d1, d2) => new Date(d1.start) - new Date(d2.start) )[0].start;
                /* Recording the earliest offered slot must never stop the
                 * slots themselves from rendering. */
                try {
                    bookingUpdater( B_ACTIONS.LOAD_SLOTS, earliestTimeSlot);
                } catch (e) {
                    console.error('Failed to record earliest offered slot', e);
                }
            }
            successCallback( r );
        } )
        .catch( error =>  failureCallback( error ))
    }, [appointmentTypeID, booking, api, selectedColour] );
    
    /* Handles a click on an event. */
    const handleClick = useCallback( eventInfo => {
        
        setSelectedEvent( eventInfo.event.extendedProps.apiEvent )
    }, [setSelectedEvent])
    
    return <> 
        <h1 className={'calHead'} >{'\'' + selectedAppTypeName + '\' Availability Calendar'}<Loading loading={loading} /></h1>
            <FullCalendar
            plugins={[ resourceTimeGridPlugin, resourceDayGridPlugin, interactionPlugin ]}
            initialView='timeGridWeek'
            businessHours= {{
                  // days of week. an array of zero-based day of week integers (0=Sunday)
                  daysOfWeek: [ 1, 2, 3, 4, 5, 6 ], // Monday - Saturday

                  startTime: dayStartTime,
                  endTime: '18:00', // an end time (6pm in this example)
            }} 
            selectable={false}
            hiddenDays={[ 0 ] /* hide */ }  
            slotDuration='00:30:00'
            slotMinTime='06:00:00'
            slotMaxTime='20:00:00'
            scrollTime='13:00:00'
            height= {'auto'}
            contentHeight={'auto'}
            stickyHeaderDates={'auto'}
            loading={setLoading}
            events={eventSource}
            editable={false}
            eventClick={handleClick}
            dayHeaderContent={(data) => getDateStr( data.date )}
            
            headerToolbar={{
               left: 'prev,next today',
                center: 'title',
            }}
            
            schedulerLicenseKey={schedulerLicenseKey}
          />
    </>
}

export default AppointmentCalendarInternal